<script>
	// Stores
	import UserStore from '@/Stores/UserStore.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let user;
	export let managers = [];

	let sending = false;
	let error;
	let managerId = user && user.account_manager_id ? user.account_manager_id.toString() : null;

	function confirmClicked() {
		sending = true;
		UserStore.updateUserManager(user.id, managerId)
			.then(() => {
				notify({
					type: 'success',
					title: 'Client Manager',
					message: 'Client Manager Updated',
					timeout: 3
				});
				UserStore.getUserWithDetails(user.id);
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Update Client Manager Failed',
					message: (e.error && e.error[0]) || 'Problem updating client manager',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Update Client Manager for {user.first_name}
			{user.last_name}
		</h2>
		<div class="flex flex-col w-full px-4 text-center">
			<fieldset>
				<div class="pt-2 my-2">
					<SelectInput className="w-full" name="manager" required bind:value={managerId}>
						<option value={null}>No manager</option>
						{#each Object.entries(managers) as manager}
							<option value={manager[0].toString()}>{manager[1]}</option>
						{/each}
					</SelectInput>
				</div>
			</fieldset>
			<LoadingButton
				on:click={confirmClicked}
				loading={sending}
				disabled={error}
				className="mt-4 mb-4 btn {error ? 'btn-primary-action-disabled' : 'btn-primary'}"
				>Update
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel [esc]</button>
		</div>
	</Modal>
{/if}
